const Spinner = () => (
  <div
    class="mr-2 inline-block h-6 w-6 animate-spin rounded-full border-4 border-solid border-blue border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
    role="status"
    style={{ alignSelf: 'center' }}
  ></div>
)

export default Spinner
